import { useQuery, keepPreviousData } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchQueryLogs = async ({ patientId, trialId, searchParams = {} }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams(searchParams);
  params.append("patient", patientId);
  params.append("trial", trialId);

  const response = await axios.get(`${__API_URL__}/api/ecrf/get_query_logs/?${params.toString()}`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetQueryLogs = ({ patientId, trialId, searchParams, enabled = true }) => {
  return useQuery({
    queryKey: ["query_logs", patientId, trialId, searchParams],
    queryFn: () => fetchQueryLogs({ patientId, trialId, searchParams }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
    placeholderData: keepPreviousData,
  });
};

export default useGetQueryLogs;
